<section class="main-loading">
  <div class="loader">
    @for (item of items; track $index) {
    <div></div>
    }
  </div>
</section>